<script setup>
import {onBeforeMount, reactive, ref} from "vue";
import YTCard from "@/components/YTCard/YTCard.vue";
import {getRoute} from "@/hooks/getRoute.js";
import moment from "moment"
import router from "@/router/index.js";
import YTCheckedPanel from "@/components/YTCheckedPanel/index.vue"
import YTActivitySignOrderState from "@/components/YTActivitySignOrderState/index.vue"
import {activitySignOrderStateEnum} from "@/enum/activitySignOrderStateEnum.js"
import {
  detailClubCompetitionOrder,
  updateClubCompetitionOrder,
} from "@/api/club/club.js";
import {detailMember} from "@/api/member/member.js";
import {itemDetail} from "@/api/goods/goods.js";
import YTDrawerItem from "@/components/YTDrawerItem/YTDrawerItem.vue";
import YTDrawerMember from "@/components/YTDrawerMember/YTDrawerMember.vue";
import {certificateTypeEnum} from "@/enum/certificateTypeEnum.js";

// 路由信息
const {route} = getRoute();

// 是否有报名id
const hasOrderNo = ref(false)
// 加载状态
const loading = ref(false)

onBeforeMount(async () => {
  hasOrderNo.value = Boolean(route.query.orderNo)
  console.log(route.query.orderNo)
  // 检测是否携带报名id
  if (!hasOrderNo.value) {
    loading.value = true
    ElMessage.error("暂无报名信息")
    return
  }
  await handleSearch()
})

// 证件类型枚举
const certificateType = ref(certificateTypeEnum)

// 获取订单信息
const handleSearch = async () => {
  try {
    loading.value = true
    const res = await detailClubCompetitionOrder(route.query.orderNo)
    console.log("res", res)
    formData.orderNo = res.orderNo
    formData.orderId = res.orderId
    formData.orderTime = moment(res.orderTime).format("YYYY-MM-DD HH:mm:ss")
    formData.nickname = res.nickname
    formData.memberId = res.memberId
    formData.phone = res.phone
    formData.activityImage = res.orderItem && res.orderItem.goodsImage ? res.orderItem.goodsImage : ""
    formData.activityName = res.orderItem && res.orderItem.goodsName ? res.orderItem.goodsName : "-"
    formData.city = res.orderItem && res.orderItem.city ? res.orderItem.city : "暂无"
    formData.activityTime = res.orderItem && (res.orderItem.startTime || res.orderItem.endTime) ? `${moment(res.orderItem.startTime).format("YYYY-MM-DD")} - ${moment(res.orderItem.endTime).format("YYYY-MM-DD")}` : "-"
    formData.state = res.orderState
    formData.allowedTriggers = res.allowedTriggers
    formData.orderItem = res.orderItem
    formData.competitionPersonInfo = res.competitionPersonInfo
    triggerList.value = []
    signTrigger.value.forEach(i => {
      let param = {
        value: i.stateId,
        name: i.stateName
      }
      triggerList.value.push(param)
    })
    loading.value = false
  } catch (e) {
    console.log(e)
  }
}

/*订单相关*/
// 活动报名订单状态枚举
const signTrigger = ref(activitySignOrderStateEnum)
// 更新报名状态可选项
const triggerList = ref([])
// 订单详情信息
const formData = reactive({
  orderNo: null,
  orderId: null,
  orderTime: null,
  nickname: null,
  memberId: null,
  phone: null,
  activityImage: null,
  activityName: null,
  city: null,
  activityTime: null,
  state: null,
  allowedTriggers: [],
  goodsId: null,
  competitionPersonInfo: null
})
// 用户信息抽屉打开状态
const drawer = ref(false)
// 处理点击用户名称跳转
const handleCustomerDetail = async (id) => {
  drawer.value = true
  drawerCacheType.value = 1
  drawerLoading.value = true
  drawerCacheInfo.value = await detailMember(id)
  drawerLoading.value = false
}
// 处理点击活动信息跳转
const handleActivityDetail = async () => {
  drawer.value = true
  drawerCacheType.value = 2
  drawerLoading.value = true
  drawerCacheInfo.value = await itemDetail(formData.orderItem.goodsId)
  drawerLoading.value = false
}
// 处理关闭用户信息抽屉
const handleCloseDrawer = () => {
  drawer.value = false
  drawerCacheType.value = null
  drawerCacheInfo.value = null
}
// 抽屉缓存类型
const drawerCacheType = ref(null)
// 抽屉缓存信息
const drawerCacheInfo = ref(null)
// 抽屉缓存加载状态
const drawerLoading = ref(false)

/*保存修改相关*/
// 保存内容提交表单
const submit = async (type) => {
  try {
    loading.value = true
    const param = {
      state: type
    }
    await updateClubCompetitionOrder(formData.orderId, param)
    loading.value = false
    ElMessage.success("修改订单状态成功")
    router.push("/listClubCompetitionSign")
  } catch (e) {
    console.log(e)
  }
}

/*页面动画相关*/
// 基本信息锚点
const baseRef = ref()

/*更新状态相关*/
// 多选弹窗打开状态
const open = ref(false)
// 处理多选框取消
const handleCancelPanel = () => {
  open.value = false
}
// 处理多选框确认
const handleConfirmPanel = async (val) => {
  await submit(val[0])
  open.value = false
}
</script>

<template>
  <el-form
      :model="formData"
      label-position="right"
      label-width="auto"
  >
    <div class="container_box mg_b_2" style="padding-bottom: 0;">
      <YTCard ref="baseRef" :title="'基本信息'" :is-show-divider="false" :is-show-title-line="true" :is-retract="false" :isCollapsed="true">
        <template #container>
          <v-skeleton-loader
              :loading="loading"
              type="list-item-three-line"
          >
            <div>
              <el-form-item label="订单编号：" prop="orderNo">
                <el-text class="mx-1" v-text="formData.orderNo"></el-text>
              </el-form-item>
              <el-form-item label="时间：" prop="orderTime">
                <el-text class="mx-1" v-text="formData.orderTime"></el-text>
              </el-form-item>
              <el-form-item label="用户：" prop="nickname">
                <el-link type="primary" v-text="`${formData.nickname}（${formData.phone}）`" :underline="false" @click="handleCustomerDetail(formData.memberId)"></el-link>
              </el-form-item>
            </div>
          </v-skeleton-loader>
        </template>
      </YTCard>
    </div>
    <div class="container_box mg_b_2" style="padding-bottom: 0;">
      <YTCard ref="baseRef" :title="'报名信息'" :is-show-divider="false" :is-show-title-line="true" :is-retract="false" :isCollapsed="true">
        <template #container>
          <v-skeleton-loader
              :loading="loading"
              type="list-item-three-line"
          >
            <div>
              <el-form-item label="姓名：" prop="name">
                <el-text v-text="`${formData.competitionPersonInfo.lastName}${formData.competitionPersonInfo.firstName}`"></el-text>
              </el-form-item>
              <el-form-item label="证件类型：" prop="certificateType">
                <el-text v-text="`${certificateType.find(i => i.stateId === formData.competitionPersonInfo.certificateType) ? certificateType.find(i => i.stateId === formData.competitionPersonInfo.certificateType).stateName : '-'}`"></el-text>
              </el-form-item>
              <el-form-item label="证件号：" prop="certificateNumber">
                <el-text v-text="`${formData.competitionPersonInfo.certificateNumber}`"></el-text>
              </el-form-item>
              <el-form-item label="血型：" prop="bloodType">
                <el-text v-text="`${formData.competitionPersonInfo.bloodType ? formData.competitionPersonInfo.bloodType : '-'}`"></el-text>
              </el-form-item>
              <el-form-item label="电子邮箱：" prop="email">
                <el-text v-text="`${formData.competitionPersonInfo.email ? formData.competitionPersonInfo.email : '-'}`"></el-text>
              </el-form-item>
              <el-form-item label="身高：" prop="heightCm">
                <el-text v-text="`${formData.competitionPersonInfo.heightCm ? formData.competitionPersonInfo.heightCm : '-'}`"></el-text>
              </el-form-item>
              <el-form-item label="体重：" prop="weightKg">
                <el-text v-text="`${formData.competitionPersonInfo.weightKg ? formData.competitionPersonInfo.weightKg : '-'}`"></el-text>
              </el-form-item>
              <el-form-item label="紧急联系人姓名：" prop="emergencyContactName">
                <el-text v-text="`${formData.competitionPersonInfo.emergencyContactName ? formData.competitionPersonInfo.emergencyContactName : '-'}`"></el-text>
              </el-form-item>
              <el-form-item label="紧急联系人手机号：" prop="emergencyContactPhone">
                <el-text v-text="`${formData.competitionPersonInfo.emergencyContactPhone ? formData.competitionPersonInfo.emergencyContactPhone : '-'}`"></el-text>
              </el-form-item>
              <el-form-item label="与紧急联系人的关系：" prop="emergencyContactRelation">
                <el-text v-text="`${formData.competitionPersonInfo.emergencyContactRelation ? formData.competitionPersonInfo.emergencyContactRelation : '-'}`"></el-text>
              </el-form-item>
              <el-form-item label="收货人姓名：" prop="receiverName">
                <el-text v-text="`${formData.competitionPersonInfo.receiverName ? formData.competitionPersonInfo.receiverName : '-'}`"></el-text>
              </el-form-item>
              <el-form-item label="收货人电话：" prop="receiverPhone">
                <el-text v-text="`${formData.competitionPersonInfo.receiverPhone ? formData.competitionPersonInfo.receiverPhone : '-'}`"></el-text>
              </el-form-item>
              <el-form-item label="收货地址：" prop="receiverAddress">
                <el-text v-text="`${formData.competitionPersonInfo.receiverAddress ? formData.competitionPersonInfo.receiverAddress : '-'}`"></el-text>
              </el-form-item>
            </div>
          </v-skeleton-loader>
        </template>
      </YTCard>
    </div>
    <div class="container_box mg_b_2" style="padding-bottom: 0">
      <YTCard :title="'活动信息'" :is-show-divider="false" :is-show-title-line="true" :is-retract="false" :isCollapsed="true">
        <template #container>
          <v-skeleton-loader
              :loading="loading"
              type="list-item-avatar-three-line"
          >
            <div class="w-100 mx-5">
              <div class="flex cursor-pointer" @click="handleActivityDetail">
                <el-image class="mg_r_1" style="width: 100px; height: 100px" :src="formData.activityImage" :fit="'contain'" />
                <div class="flex_align_t flex_warp flex_1">
                  <div class="w-100">
                    <strong>
                      <el-text class="mx-1" size="large" v-text="formData.activityName"></el-text>
                    </strong>
                    <div>
                      <el-text class="mx-1" type="info" size="small" v-text="`城市：${formData.city}`"></el-text>
                    </div>
                    <div>
                      <el-text class="mx-1" type="info" size="small" v-text="`时间：${formData.activityTime}`"></el-text>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </v-skeleton-loader>
        </template>
      </YTCard>
    </div>
    <div class="container_box mg_b_2" style="padding-bottom: 0">
      <YTCard :title="'报名状态'" :is-show-divider="false" :is-show-title-line="true" :is-retract="false" :isCollapsed="true">
        <template #container>
          <v-skeleton-loader
              :loading="loading"
              type="list-item"
          >
            <el-form-item label="报名状态：" prop="orderState">
              <YTActivitySignOrderState class="mg_r_2" :state="formData.state"></YTActivitySignOrderState>
              <v-btn color="success" @click="open = true" v-if="formData.allowedTriggers.length > 0">更新状态</v-btn>
            </el-form-item>
          </v-skeleton-loader>
        </template>
      </YTCard>
    </div>
    <div>
      <v-row>
        <v-col>
          <v-btn @click="router.back()">返回</v-btn>
        </v-col>
      </v-row>
    </div>
  </el-form>
  <YTCheckedPanel
      v-if="open"
      :open="open"
      :title="'订单状态'"
      :list="triggerList"
      :hasAll="false"
      :checked-limit="1"
      @cancel="handleCancelPanel"
      @confirm="handleConfirmPanel">
  </YTCheckedPanel>
  <el-drawer
      v-model="drawer"
      :title="drawerCacheType === 1 ? '用户信息' : '活动信息'"
      direction="rtl"
      :close="handleCloseDrawer"
      style="text-align: left"
      :size="drawerCacheType === 1 ? '30%' : '50%'"
  >
    <el-skeleton v-if="drawerLoading" :rows="5" animated />
    <div v-else>
      <div v-if="drawerCacheType === 1">
        <YTDrawerMember :drawer-cache-info="drawerCacheInfo"></YTDrawerMember>
      </div>
      <div v-else>
        <YTDrawerItem :drawer-cache-info="drawerCacheInfo"></YTDrawerItem>
      </div>
    </div>
  </el-drawer>
</template>

<style scoped>

</style>